import type { AuthorizedResourceAccessMap } from '@/permissions/adapter';

export default function access(
  initialState:
    | { authorizedResourceAccess?: AuthorizedResourceAccessMap }
    | undefined,
) {
  const permissions = initialState?.authorizedResourceAccess ?? {};
  return {
    ...permissions,
    canViewEmployeeContent: Boolean(
      permissions['policy-my-pending'] || permissions['policy-my-history'],
    ),
    canViewPolicyVersion: [
      'policy-contents',
      'policy-reviews',
      'policy-archive',
      'policy-receipts',
    ].some((code) => permissions[code]),
  };
}
